export default {
    subscriptionsTitle: 'Solicitudes de suscripción',
    subscriptionsMenu: 'Suscripciones',
    subscriptionsSubtitle: 'Revisa y resuelve las solicitudes de cambio de plan de los tenants',
    subColTenant: 'Tenant',
    subColChange: 'Cambio',
    subColType: 'Tipo',
    subColStatus: 'Estado',
    subColDate: 'Fecha',
    subColActions: 'Acciones',
    subColNotes: 'Notas',
    typeInitial: 'Inicial',
    typeUpgrade: 'Upgrade',
    typeDowngrade: 'Downgrade',
    statusPending: 'Pendiente',
    statusApproved: 'Aprobada',
    statusRejected: 'Rechazada',
    filterAll: 'Todas',
    approve: 'Aprobar',
    reject: 'Rechazar',
    noRequests: 'No hay solicitudes de suscripción',
    approveSuccess: 'Solicitud aprobada y plan actualizado',
    rejectSuccess: 'Solicitud rechazada',
    approveError: 'Error al aprobar la solicitud',
    rejectError: 'Error al rechazar la solicitud',
    loadError: 'Error al cargar las solicitudes',
    confirmReject: '¿Deseas rechazar esta solicitud de cambio de plan?',
    conflictsTitle: 'El consumo actual excede los límites del nuevo plan',
    conflictsForce: '¿Forzar el downgrade de todas formas? Se cancelarán los add-ons incompatibles.',
    noPlan: 'Sin plan',
};
